import { render, staticRenderFns } from "./PatientAlertFiltersRep.vue?vue&type=template&id=84fcbd58&"
import script from "./PatientAlertFiltersRep.vue?vue&type=script&lang=js&"
export * from "./PatientAlertFiltersRep.vue?vue&type=script&lang=js&"
import style0 from "./PatientAlertFiltersRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports